module.exports = __webpack_public_path__ + "img/reset_floodlight_step_2.5e14794e.png";